"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeforeApplicationExitHook = exports.ApplicationStartedHook = exports.ApplicationReadyHook = void 0;
const hooks_1 = require("../hooks");
/**
 * Hook executed when the application is ready.
 *
 * @remarks At this step, plugins and modules are installed and ready.
 */
class ApplicationReadyHook extends hooks_1.BaseHook {
    constructor(sender, applicationContext) {
        super(sender);
        this.applicationContext = applicationContext;
    }
}
exports.ApplicationReadyHook = ApplicationReadyHook;
/**
 * Hook executed when the application has started.
 *
 * @remarks At this step, plugins with a background task are running (for example: an HTTP server listening).
 */
class ApplicationStartedHook extends hooks_1.BaseHook {
    constructor(sender, applicationContext) {
        super(sender);
        this.applicationContext = applicationContext;
    }
}
exports.ApplicationStartedHook = ApplicationStartedHook;
/**
 * Hook executed before the application exits.
 *
 * @remarks This hook is not triggered by default. It is necessary to install a plugin capable of triggering it.
 *
 * @see DefaultShutdownPlugin
 * @see GlobalErrorHandlerPlugin
 */
class BeforeApplicationExitHook extends hooks_1.BaseHook {
}
exports.BeforeApplicationExitHook = BeforeApplicationExitHook;
//# sourceMappingURL=lifecycle.js.map